import BlogContainer from 'UI/views/Blog';
import { wrapper } from 'redux/store';
import { getInitialBlogProps } from 'utils/blogUtils';

export const getStaticProps = wrapper.getStaticProps(
  (store) => async (ctx) => getInitialBlogProps(store, ctx),
);

export default BlogContainer;
